import Utility from "./utility";
import amplitude from "amplitude-js";
import {
  ampUserProperties,
  getAmplitudeInstance,
} from "../config/amplitudeKeys";
import { keyMapsGetter } from "./storeKeys";
import store from "../store/index";
import {
  VWO_HOMEPAGE_EXPERIMENT,
  VWO_VARIANT_HOMEPAGE_HEADER_NAME,
  VWO_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import LocalStorageFunc from "./localStorageFunc";
import StorageKeys from "../config/storageKeys";
import { OrderTypesCode } from "../helpers/orderTypesConstants";

const setEvents = (eventDestination, name, eventProperties) => {
  if (eventDestination == "amplitude") {
    loadAmplitudeEvents(name, eventProperties);
  } else if (eventDestination == "moengage") {
    loadMoengageEvents(name, eventProperties);
  } else if (eventDestination == "ga") {
    loadGaEvents(name, eventProperties);
  } else if (eventDestination == "meta") {
    loadMetaEvents(name, eventProperties);
  }
};

const loadMoengageEvents = (event, eventProperties) => {
  if (window.Moengage !== undefined) {
    window.Moengage.track_event(event, eventProperties);
  }
};

const loadGaEvents = (event, eventProperties) => {
  if (window.gtag !== undefined && window.gtagEventsTemp?.length == 0) {
    gtag("event", event, eventProperties);
  } else {
    if (!window.gtagEventsTemp) {
      window.gtagEventsTemp = [];
    }
    window.gtagEventsTemp.push({
      event: event,
      eventProperties: eventProperties,
    });
  }
};

const loadGaUnsentEvents = () => {
  if (window.gtag === undefined) return;

  window.gtagEventsTemp?.forEach((gtagEventTemp) => {
    gtag("event", gtagEventTemp.event, gtagEventTemp.eventProperties);
  });
  window.gtagEventsTemp = [];
};

const loadMetaEvents = (event, eventProperties) => {
  eventProperties = updateEventPropsBasedOnVwoVariant(eventProperties);
  eventProperties.Events_time_stamp = new Date().getTime(); //timeStamp in every event

  if (
    Object.keys(store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS])?.length &&
    window.metaEventsTemp?.length == 0 &&
    typeof window?.fbq === "function"
  ) {
    window.fbq("track", event);
  } else {
    if (!window.metaEventsTemp) {
      window.metaEventsTemp = [];
    }
    window.metaEventsTemp.push({
      event: event,
      eventProperties: eventProperties,
    });
  }
};

const loadAmplitudeEvents = (event, eventProperties) => {
  eventProperties = updateEventPropsBasedOnVwoVariant(eventProperties);
  eventProperties.Events_time_stamp = new Date().getTime(); //timeStamp in every event

  if (
    Object.keys(store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS])?.length &&
    window.amplitudeEventsTemp?.length == 0
  ) {
    getAmplitudeInstance().logEvent(event, eventProperties);
  } else {
    if (!window.amplitudeEventsTemp) {
      window.amplitudeEventsTemp = [];
    }
    window.amplitudeEventsTemp.push({
      event: event,
      eventProperties: eventProperties,
    });
  }
};

const loadAmplitudeUnsentEvents = (param) => {
  getAmplitudeInstance().setUserProperties({
    ...(ampUserProperties() || {}),
    [VWO_VARIANT_HOMEPAGE_HEADER_NAME]:
      Utility.tryJsonParse(sessionStorage.VWO_VARIATIONS)?.[
        VWO_HOMEPAGE_EXPERIMENT
      ] || "N/A",
  });

  window.amplitudeEventsTemp?.forEach((amplitudeEventTemp) => {
    getAmplitudeInstance().logEvent(
      amplitudeEventTemp.event,
      amplitudeEventTemp.eventProperties,
    );
  });
  window.amplitudeEventsTemp = [];
};

const updateAmplitudeUserProperties = (properties = {}) => {
  getAmplitudeInstance().setUserProperties(properties);
};

const updateEventPropsBasedOnVwoVariant = (eventProperties) => {
  let exp = store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS];
  if (exp?.[VWO_HOMEPAGE_EXPERIMENT] === VWO_EXPERIMENT_VARIANTS.VARIANT_A) {
    //eventProperties.Page_Name === "hongs home page";
  }
  return eventProperties;
};

const getAmplitudeEventObj = (eObj) => {
  return {
    ...(eObj.userAction && {
      userAction: eObj.userAction,
    }),
    ...(eObj.sectionName && {
      sectionName: eObj.sectionName,
    }),
    ...(eObj.sectionPosition && {
      sectionPosition: eObj.sectionPosition,
    }),
    ...(eObj.positionWithinSection && {
      positionWithinSection: eObj.positionWithinSection,
    }),
    ...(eObj.category && { category: eObj.category }),
    ...(eObj.subCategory && { subCategory: eObj.subCategory }),
    ...(eObj.categoryPosition && {
      categoryPosition: eObj.categoryPosition,
    }),
    ...(eObj.cartValue && {
      cartValue: eObj.cartValue,
    }),
    ...(eObj.discount && {
      discount: eObj.discount,
    }),
    ...(eObj.discountAmount && {
      discountAmount: eObj.discountAmount,
    }),
    ...(eObj.itemName && {
      itemName: eObj.itemName,
    }),
    ...(eObj.itemSku && {
      itemSku: eObj.itemSku,
    }),
    ...(eObj.quantity && {
      quantity: eObj.quantity,
    }),
    ...(eObj.price && {
      price: eObj.price,
    }),
    ...(eObj.amount && {
      amount: eObj.amount,
    }),
    ...(eObj.totalCartAmount && {
      totalCartAmount: eObj.totalCartAmount,
    }),
    ...(eObj.totalCartQuantity && {
      totalCartQuantity: eObj.totalCartQuantity,
    }),
    ...(eObj.subTotal && {
      subTotal: eObj.subTotal,
    }),
    ...(eObj.defaultPaymentMode && {
      defaultPaymentMode: eObj.defaultPaymentMode,
    }),
    ...(eObj.totalQuantity && {
      totalQuantity: eObj.totalQuantity,
    }),
    ...(eObj.cartId && {
      cartId: eObj.cartId,
    }),
    ...(eObj.orderId && {
      orderId: eObj.orderId,
    }),
    ...(eObj.paymentSummary && {
      paymentSummary: eObj.paymentSummary,
    }),
    ...(eObj.deliveryOrderTypeSummary && {
      deliveryOrderTypeSummary: eObj.deliveryOrderTypeSummary,
    }),
    ...(eObj.invalidItemsInCart && {
      invalidItemsInCart: eObj.invalidItemsInCart,
    }),
    ...(eObj.invalidItemsName && {
      invalidItemsName: eObj.invalidItemsName,
    }),
    ...(eObj.isComboCart && {
      isComboCart: eObj.isComboCart,
    }),
    ...(eObj.isVegCart && {
      isVegCart: eObj.isVegCart,
    }),
    ...(eObj.paymentMethodSaved && {
      paymentMethodSaved: eObj.paymentMethodSaved,
    }),
    ...(eObj.paymentMethod && {
      paymentMethod: eObj.paymentMethod,
    }),
    ...(eObj.secondaryPaymentMethod && {
      secondaryPaymentMethod: eObj.secondaryPaymentMethod,
    }),
    ...(eObj.addressSaved && {
      addressSaved: eObj.addressSaved,
    }),
    ...(eObj.couponStatus && {
      couponStatus: eObj.couponStatus,
    }),
    ...(eObj.deliveryType && {
      deliveryType: eObj.deliveryType,
    }),
    ...(eObj.itemSKU && {
      itemSKU: eObj.itemSKU,
    }),
    ...(eObj.addCounter ||
      (eObj.addCounter == 0 && {
        addCounter: eObj.addCounter,
      })),
    ...(eObj.isVegItem && {
      isVegItem: eObj.isVegItem,
    }),
    ...(eObj.itemOriginalPrice && {
      itemOriginalPrice: eObj.itemOriginalPrice,
    }),
    ...(eObj.itemPosition && {
      itemPosition: eObj.itemPosition,
    }),
    ...(eObj.itemCategory && {
      itemCategory: eObj.itemCategory,
    }),
    ...(eObj.isCustomizedItem && {
      isCustomizedItem: eObj.isCustomizedItem,
    }),
    ...(eObj.freeItem && {
      freeItem: eObj.freeItem,
    }),
    ...(eObj.freeItemCategory && {
      freeItemCategory: eObj.freeItemCategory,
    }),
    ...(eObj.lastCartItem && {
      lastCartItem: eObj.lastCartItem,
    }),
    ...(eObj.noOfItemsAvailable && {
      noOfItemsAvailable: eObj.noOfItemsAvailable,
    }),
    ...(eObj.noOfCategoriessAvailable && {
      noOfCategoriessAvailable: eObj.noOfCategoriessAvailable,
    }),
    ...(eObj.itemsCountInCategory && {
      itemsCountInCategory: eObj.itemsCountInCategory,
    }),
    ...(eObj.effective_grand_total && {
      effective_grand_total: eObj.effective_grand_total,
    }),
    ...(eObj.grand_total && {
      grand_total: eObj.grand_total,
    }),
    ...(eObj.strike_grand_total && {
      strike_grand_total: eObj.strike_grand_total,
    }),
    ...(eObj.sub_total && {
      sub_total: eObj.sub_total,
    }),
    ...(eObj.total_tax && {
      total_tax: eObj.total_tax,
    }),
    ...(eObj.GST && {
      tax: eObj.GST,
    }),
    ...(eObj.charge_D && {
      delivery_charge: eObj.charge_D,
    }),
    ...(eObj.charge_P && {
      packaging_charge: eObj.charge_P,
    }),
    ...(eObj.currentMode && {
      currentMode: eObj.currentMode,
    }),
    ...(eObj.updatedMode && {
      updatedMode: eObj.updatedMode,
    }),
    ...(eObj.distanceDiff && {
      distanceDiff: eObj.distanceDiff,
    }),
    ...(eObj.deliveryTime && {
      deliveryTime: eObj.deliveryTime,
    }),
    ...(eObj.productName && {
      productName: eObj.productName,
    }),
    ...(eObj.productPrice && {
      productPrice: eObj.productPrice,
    }),
    ...(eObj.productQuantity && {
      productQuantity: eObj.productQuantity,
    }),
    ...(eObj.discountAmount && {
      discountAmount: eObj.discountAmount,
    }),
    ...(eObj.isScheduledToday && {
      isScheduledToday: eObj.isScheduledToday,
    }),
    ...(eObj.eventCategory && {
      eventCategory: eObj.eventCategory,
    }),
    ...(eObj.isCartLoaded && {
      isCartLoaded: eObj.isCartLoaded,
    }),
    ...(eObj.locationPermission && {
      locationPermission: eObj.locationPermission,
    }),
    ...(eObj.addressAvailability && {
      addressAvailability: eObj.addressAvailability,
    }),
    ...(eObj.addressStatus && {
      addressStatus: eObj.addressStatus,
    }),
    ...(eObj.OrderType && {
      OrderType: eObj.OrderType,
    }),
    ...(eObj.deliveryETA && {
      deliveryETA: eObj.deliveryETA,
    }),
    ...(eObj.deliveryGuarantee && {
      deliveryGuarantee: eObj.deliveryGuarantee,
    }),
    ...(eObj.savings && {
      savings: eObj.savings,
    }),
    ...(eObj.comboApplied && {
      comboApplied: eObj.comboApplied,
    }),
    ...(eObj.searchTerm && {
      searchTerm: eObj.searchTerm,
    }),
    ...(eObj.eventAction && {
      eventAction: eObj.eventAction,
    }),
    ...(eObj.eventLabel && {
      eventLabel: eObj.eventLabel,
    }),
    ...(eObj.tipValue && {
      tipValue: eObj.tipValue,
    }),
    ...(eObj.subcategory && {
      subcategory: eObj.subcategory,
    }),
    ...(eObj.orderType && {
      orderType: eObj.orderType,
    }),
    ...(eObj.orderStatus && {
      orderStatus: eObj.orderStatus,
    }),
    ...(eObj.checkoutOption && {
      checkoutOption: eObj.checkoutOption,
    }),
    ...(eObj.checkoutStep && {
      checkoutStep: eObj.checkoutStep,
    }),
    ...(eObj.checkoutStage && {
      checkoutStage: eObj.checkoutStage,
    }),
    ...(eObj.address && {
      address: eObj.address,
    }),
    ...(eObj.orderNumber && {
      orderNumber: eObj.orderNumber,
    }),
    ...(eObj.orderDate && {
      orderDate: eObj.orderDate,
    }),
    ...(eObj.productName && {
      productName: eObj.productName,
    }),
    ...(eObj.productPrice && {
      productPrice: eObj.productPrice,
    }),
    ...(eObj.popeyesWalleFlag && {
      popeyesWalleFlag: eObj.popeyesWalleFlag,
    }),
    ...(eObj.popeyesWalletAmount && {
      popeyesWalletAmount: eObj.popeyesWalletAmount,
    }),
    ...(eObj.walletAmount && {
      walletAmount: eObj.walletAmount,
    }),
    ...(eObj.totalCashbackAvailable && {
      totalCashbackAvailable: eObj.totalCashbackAvailable,
    }),
    ...(eObj.couponName && {
      couponName: eObj.couponName,
    }),
    ...(eObj.couponAmount && {
      couponAmount: eObj.couponAmount,
    }),
    ...(eObj.itemTotal && {
      itemTotal: eObj.itemTotal,
    }),
    ...(eObj.tax && {
      tax: eObj.tax,
    }),
    ...((eObj.isCombo || eObj.isCombo == 0) && {
      isCombo: eObj.isCombo,
    }),
    ...((eObj.isCustomisable || eObj.isCustomisable == 0) && {
      isCustomisable: eObj.isCustomisable,
    }),
    ...(eObj.defaultParentProduct && {
      defaultParentProduct: eObj.defaultParentProduct,
    }),
    ...(eObj.defaultSide && {
      defaultSide: eObj.defaultSide,
    }),
    ...(eObj.defaultBevrage && {
      defaultBevrage: eObj.defaultBevrage,
    }),
    ...(eObj.preferredParentProduct && {
      preferredParentProduct: eObj.preferredParentProduct,
    }),
    ...(eObj.preferredSide && {
      preferredSide: eObj.preferredSide,
    }),
    ...(eObj.preferredBevrage && {
      preferredBevrage: eObj.preferredBevrage,
    }),
    ...(eObj.customizedPrice && {
      customizedPrice: eObj.customizedPrice,
    }),
    ...(eObj.upsellProductName && {
      upsellProductName: eObj.upsellProductName,
    }),
    ...(eObj.upsellProductPrice && {
      upsellProductPrice: eObj.upsellProductPrice,
    }),
    ...(eObj.inititalProductQuantity && {
      inititalProductQuantity: eObj.inititalProductQuantity,
    }),
    ...(eObj.gridSize && {
      gridSize: eObj.gridSize,
    }),
    ...(eObj.errorMessage && {
      errorMessage: eObj.errorMessage,
    }),
    ...(eObj.previousOrderMode && {
      previousOrderMode: eObj.previousOrderMode,
    }),
    ...(eObj.deliveryCharge && {
      deliveryCharge: eObj.deliveryCharge,
    }),
    ...(eObj.couponDetail && {
      couponDetail: eObj.couponDetail,
    }),
    ...(eObj.taxChargesCategory && {
      taxChargesCategory: eObj.taxChargesCategory,
    }),
    ...(eObj.taxChargesAmount && {
      taxChargesAmount: eObj.taxChargesAmount,
    }),
    ...(eObj.couponDetail && {
      couponDetail: eObj.couponDetail,
    }),
    ...(eObj.failureReason && {
      failureReason: eObj.failureReason,
    }),
    ...(eObj.coupon && {
      coupon: eObj.coupon,
    }),
    screenName: eObj.screenName
      ? eObj.screenName
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HOME_PAGE,
        ),
    Page_Name: eObj.screenName
      ? eObj.screenName
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HOME_PAGE,
        ),
    previousScreenname: eObj.previousScreenname
      ? eObj.previousScreenname
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.PREVIOUS_SCREEN_NAME,
          document.referrer,
        ),
  };
};

const getGaEventObj = (eObj) => {
  return {
    ...(eObj.ecommerce && {
      ecommerce: JSON.stringify(eObj.ecommerce),
    }),
    ...(eObj.loginMethod && {
      loginMethod: eObj.loginMethod,
    }),
    ...(eObj.eventCategory && {
      eventCategory: eObj.eventCategory,
    }),
    ...(eObj.eventAction && {
      eventAction: eObj.eventAction,
    }),
    ...(eObj.eventLabel && {
      eventLabel: eObj.eventLabel,
    }),
    ...(eObj.couponCode && {
      couponCode: eObj.couponCode,
    }),
    ...(eObj.couponName && {
      couponName: eObj.couponName,
    }),
    ...(eObj.couponAmount && {
      couponAmount: eObj.couponAmount,
    }),
    ...(eObj.couponIndex && {
      couponIndex: eObj.couponIndex,
    }),
    ...(eObj.upsellProductName && {
      upsellProductName: eObj.upsellProductName,
    }),
    ...(eObj.productName && {
      productName: eObj.productName,
    }),
    ...(eObj.customizationOption && {
      customizationOption: eObj.customizationOption,
    }),
    ...(eObj.sendTo && {
      sendTo: eObj.sendTo,
    }),
    ...(eObj.value && {
      value: eObj.value,
    }),
    ...(eObj.currency && {
      currency: eObj.currency,
    }),
    ...(eObj.transactionId && {
      transactionId: eObj.transactionId,
    }),
    ...(ampUserProperties() || {}),
    pageName: eObj.screenName
      ? eObj.screenName
      : LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HOME_PAGE,
        ),
    userStatus: LocalStorageFunc.isLoggedIn(),
  };
};

const getGaEcommerceValueOneItem = () => {
  const lp = store.state.Cart.lastInteractedProductCard;
  const parentCategory =
    store.state.ProductItems.productCategoryMapShort[
      store.state.ProductItems.productCategoryToParentCategoryMap[
        lp.categoryId
      ] || ""
    ] || "";
  return {
    items: [
      {
        item_id: lp.productId,
        item_name: lp.productName,
        affiliation: "Hong's Kitchen PWA",
        coupon: "",
        currency: "INR",
        discount: "",
        index: lp.index,
        item_brand: "",
        item_category:
          parentCategory ||
          store.state.ProductItems.productCategoryMapShort[lp.categoryId],
        item_category2: parentCategory
          ? store.state.ProductItems.productCategoryMapShort[lp.categoryId] ||
            ""
          : "",
        item_category3: lp.selectedVariant,
        item_category4: "",
        item_category5: "",
        item_list_id: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HOME_PAGE,
        ),
        item_list_name: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HOME_PAGE,
        ),
        item_variant: lp.selectedVariant,
        location_id: LocalStorageFunc.storeId(),
        price: lp.currentPrice,
        quantity: 1,
      },
    ],
  };
};

const getGaEcommerceValueForAllItem = () => {
  const cItemIterator = store.state.Cart.cartItemsListingPageIterator;

  return {
    items: Object.keys(cItemIterator).map((itemId, index) => {
      return {
        item_id: itemId,
        item_name: cItemIterator[itemId].displayName,
        affiliation: "Hong's Kitchen PWA",
        coupon: "",
        currency: "INR",
        discount: "",
        index,
        item_brand: "",
        item_category: "",
        item_category2: "",
        item_category3:
          cItemIterator[itemId]?.selectedVariant?.displayName || "",
        item_category4: "",
        item_category5: "",
        item_list_id: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HOME_PAGE,
        ),
        item_list_name: LocalStorageFunc.getSessionStorageKey(
          StorageKeys.SCREEN_NAME,
          PageNames.HOME_PAGE,
        ),
        item_variant: cItemIterator[itemId]?.selectedVariant?.displayName || "",
        location_id: LocalStorageFunc.storeId(),
        price: Utility.getProductCurrentPrice(cItemIterator[itemId]),
        quantity: cItemIterator[itemId].quantity, // todo : check and implement accordingly
      };
    }),
  };
};

const updateScreenPreviousScreen = (screenNameShouldBe) => {
  let screenNameFromStorage = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.SCREEN_NAME,
    "",
  );
  if (screenNameFromStorage != screenNameShouldBe) {
    updateAmplitudeUserProperties({
      screenName: screenNameShouldBe,
      previousScreenname: screenNameFromStorage,
    });
    LocalStorageFunc.setSessionStorageKey(
      StorageKeys.PREVIOUS_SCREEN_NAME,
      screenNameFromStorage,
    );
    LocalStorageFunc.setSessionStorageKey(
      StorageKeys.SCREEN_NAME,
      screenNameShouldBe,
    );
  }
};

const EVENT_PAGEVIEW_HOMEPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.HOME_PAGE;

  updateScreenPreviousScreen(PageNames.HOME_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_SEARCHPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.SEARCH_PAGE;

  updateScreenPreviousScreen(PageNames.SEARCH_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_OFFERSPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.OFFERS_PAGE;

  updateScreenPreviousScreen(PageNames.OFFERS_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_MENUPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.MENU_PAGE;

  updateScreenPreviousScreen(PageNames.MENU_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_PROFILEPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.PROFILE_PAGE;

  updateScreenPreviousScreen(PageNames.PROFILE_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_ORDERHISTORYPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.ORDERHISTORY_PAGE;

  updateScreenPreviousScreen(PageNames.ORDERHISTORY_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_ADDRESSESPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.ADDRESSES_PAGE;

  updateScreenPreviousScreen(PageNames.ADDRESSES_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_FAVOURITEPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.FAVOURITE_PAGE;

  updateScreenPreviousScreen(PageNames.FAVOURITE_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_LOGINPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.LOGIN_PAGE;

  updateScreenPreviousScreen(PageNames.LOGIN_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_CARTPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.CART_PAGE;

  updateScreenPreviousScreen(PageNames.CART_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_PAGEVIEW_LOCATIONPAGE = (eObj = {}) => {
  eObj["screenName"] = PageNames.LOCATION_PAGE;

  updateScreenPreviousScreen(PageNames.LOCATION_PAGE);

  eObj["previousScreenname"] = LocalStorageFunc.getSessionStorageKey(
    StorageKeys.PREVIOUS_SCREEN_NAME,
    "",
  );

  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
  setEvents("ga", "page_view", getGaEventObj(eObj));
  setEvents("meta", "FB_PageView", {});
};

const EVENT_CLICK_SEARCHICON = (eObj = {}) => {
  eObj["category"] = "opened";
  eObj["userAction"] = "click";
  eObj["sectionName"] = "search";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_click", getGaEventObj(eObj));
};

const EVENT_TYPE_SEARCHINPUT = (eObj = {}) => {
  eObj["sectionName"] = "search";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "search_field_interacted", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_field_interacted", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_SEARCHRESULT = (eObj = {}) => {
  eObj["userAction"] = "product search icon click";
  eObj["sectionName"] = "product search on menu";

  setEvents("amplitude", "product_search", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_value_shown", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_PROMOTION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "promotion";
  eObj["sectionPosition"] = "3";

  //setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "view_promotion", getGaEventObj(eObj));
};

const EVENT_CLICK_SEARCHOPTION = (eObj = {}) => {
  eObj["userAction"] = "popular search";

  setEvents("amplitude", "popular_searches", getAmplitudeEventObj(eObj));
  setEvents("ga", "search_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_PROMOTION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "promotion";
  eObj["sectionPosition"] = "3";

  //setEvents("amplitude", "select_promotion", getAmplitudeEventObj(eObj));
  setEvents("ga", "select_promotion", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_OFFERS = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "promotion impression";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_ORDERTYPE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "order type toggle";
  eObj["sectionPosition"] = "3";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  switch (eObj["orderType"]) {
    case OrderTypesCode.DELIVERY_CODE:
      setEvents("ga", "delivery_mode_selected", getGaEventObj(eObj));
      break;
    case OrderTypesCode.TAKEAWAY_CODE:
      setEvents("ga", "takeaway_mode_selected", getGaEventObj(eObj));
      break;
    case OrderTypesCode.DINE_IN_CODE:
      setEvents("ga", "dinein_mode_selected", getGaEventObj(eObj));
      break;
  }
};

const EVENT_IMPRESSION_INLINENOTIFICATION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Notification Message";
  eObj["sectionPosition"] = "2";
  eObj["positionWithinSection"] = "1";
  eObj["category"] = "Notification Message";

  setEvents("amplitude", "impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "inline_notification_visible", getGaEventObj(eObj));
};

const EVENT_CLICK_INLINENOTIFICATION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "inline notification";
  eObj["sectionPosition"] = "2";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "inline_notification_interacted", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_UPSELL_ITEM = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "upsell";
  eObj["sectionPosition"] = "1";

  setEvents("ga", "upsell_item_impression", getGaEventObj(eObj));
};

const EVENT_CLICK_UPSELL_ITEM = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "upsell";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "upsell_item_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_FILTERS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "home page menu";
  eObj["sectionPosition"] = "6";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  switch (eObj["category"]) {
    case "Veg":
      setEvents("ga", "veg_filter_clicked", getGaEventObj(eObj));
      break;
    case "Non-Veg":
      setEvents("ga", "non_veg_filter_clicked", getGaEventObj(eObj));
      break;
  }
};

const EVENT_CLICK_MENU_CATEGORY = (eObj = {}) => {
  eObj["sectionName"] = "menu category";

  setEvents("amplitude", "menu_category", getAmplitudeEventObj(eObj));
  setEvents("ga", "upsell_item_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_BOTTOM_STICKY_BAR = (eObj = {}) => {
  eObj["userAction"] = "bottom nav selection";
  eObj["sectionName"] = "bottom navigation";

  setEvents("amplitude", "bottom_nav", getAmplitudeEventObj(eObj));
  setEvents("ga", "upsell_item_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_FAVOURITE_BUTTON = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "favourite";

  setEvents("ga", "favourite_button_clicked", getGaEventObj(eObj));
};
const EVENT_CLICK_ADDRESS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "address selection";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "change_address_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_ADDTOCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "add to cart";
  eObj["sectionPosition"] = "8"; //cartId
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "add to cart";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueOneItem();
  setEvents("ga", "add_to_cart", getGaEventObj(eObj));
  setEvents("meta", "FB_AddToCart", {});
};

const EVENT_CLICK_REMOVEFROMCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "remove from cart";
  eObj["sectionPosition"] = "8"; //cartId
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "remove from cart";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueOneItem();
  setEvents("ga", "remove_from_cart", getGaEventObj(eObj));
  setEvents("meta", "FB_RemoveFromCart", {});
};

const EVENT_CLICK_EDITITEMINCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "edit item";
  eObj["sectionPosition"] = "8";
  eObj["category"] = "edit item";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "edit_product_click", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEWCART = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["eventAction"] = "pressed cart view icon";
  eObj["isCartLoaded"] = "1";
  eObj["sectionName"] = "view cart";
  eObj["sectionPosition"] = "15";

  setEvents("amplitude", "view_cart_icon", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueForAllItem();
  setEvents("ga", "view_cart", getGaEventObj(eObj));
};

const EVENT_HAMBURGER_OPENED = (eObj = {}) => {
  setEvents("amplitude", "hamburger_menu", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_opened", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_CUSTOMIZATION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "customization";
  eObj["sectionPosition"] = "1";

  setEvents("ga", "customization_option_visible", getGaEventObj(eObj));
};

const EVENT_CLICK_CUSTOMIZATION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionPosition"] = "8";
  eObj["category"] = "customization";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_CUSTOMIZATION_COMBO = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionPosition"] = "8";
  eObj["category"] = "customization";

  setEvents("ga", "customization_option_interacted", getGaEventObj(eObj));
};

const EVENT_TYPE_MOBILENUMBER = (eObj = {}) => {
  eObj["userAction"] = "number input";
  eObj["sectionName"] = "login-app";
  eObj["category"] = "manual";

  setEvents("amplitude", "number_input", getAmplitudeEventObj(eObj));
  setEvents("ga", "phone_number_input_attempt", getGaEventObj(eObj));
};

const EVENT_HAMBURGER_CLOSED = (eObj = {}) => {
  eObj["userAction"] = "hamburger menu close";

  setEvents("amplitude", "hamburger_menu", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_closed", getGaEventObj(eObj));
};

const EVENT_CLICK_SENDOTP = (eObj = {}) => {
  eObj["userAction"] = "sent otp for login";
  eObj["sectionName"] = " login - otp";
  eObj["category"] = "manual-sent";
  eObj["subCategory"] = "login-app";

  setEvents("amplitude", "send_otp", getAmplitudeEventObj(eObj));
  setEvents("ga", "send_otp_clicked", getGaEventObj(eObj));
};

const EVENT_HAMBURGER_LIST_ITEM_CLICKED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";

  setEvents("amplitude", "hamburger_sections", getAmplitudeEventObj(eObj));
  // setEvents(
  //   "ga",
  //   `hamburger_link_clicked - ${eObj["subCategory"]}`,
  //   getGaEventObj(eObj)
  // );
};

const EVENT_LOGIN_CTA_CLICKED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";
  eObj["sectionPosition"] = "1";
  eObj["positionWithinSection"] = "2";
  eObj["category"] = "Login";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_login_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_CHANGEMOBILENUMBER = (eObj = {}) => {
  eObj["userAction"] = "change number";
  eObj["sectionName"] = "otp input";

  setEvents("amplitude", "change_number", getAmplitudeEventObj(eObj));
  setEvents("ga", "change_mobile_click", getGaEventObj(eObj));
};

const EVENT_CLICK_LOGIN_SKIP = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "login skip";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "skip_login_click", getGaEventObj(eObj));
};

const EVENT_LOGOUT_CTA_CLICKED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "hamburger";
  eObj["sectionPosition"] = "1";
  eObj["positionWithinSection"] = "2";
  eObj["category"] = "Logout";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "hamburger_logout_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_RESENDSMS = (eObj = {}) => {
  eObj["userAction"] = "resend otp";
  eObj["sectionName"] = "otp input";

  setEvents("amplitude", "resend_otp", getAmplitudeEventObj(eObj));
  setEvents("ga", "resend_sms_click", getGaEventObj(eObj));
};

const EVENT_CLICK_TRACKORDER = (eObj = {}) => {
  eObj["userAction"] = "track_order";
  eObj["sectionName"] = "previous order card";

  setEvents("amplitude", "track_order", getAmplitudeEventObj(eObj));
  setEvents("ga", "track_button_click", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_TRACKORDER = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "trackPage";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_TYPE_OTP = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "Enter OTP";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "otp_entered", getGaEventObj(eObj));
};

const EVENT_CLICK_SUBMITOTP = (eObj = {}) => {
  eObj["userAction"] = "submit otp";
  eObj["sectionName"] = "login";

  setEvents("amplitude", "submit_otp", getAmplitudeEventObj(eObj));
  setEvents("ga", "submit_otp_click", getGaEventObj(eObj));
};

const EVENT_OTP_DETECTED = (eObj = {}) => {
  eObj["userAction"] = "otp detected";
  eObj["sectionName"] = "login-app";
  setEvents("amplitude", "otp_detected", getAmplitudeEventObj(eObj));
};

const EVENT_AUTO_LOGIN_TRIGGERED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "auto-login";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_login", getGaEventObj(eObj));
};

const EVENT_CLICK_AUTO_FETCH_MOBILE_NO = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "phone number";
  eObj["subcategory"] = "auto-fetch";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_fetch_mobile_no", getGaEventObj(eObj));
};

const EVENT_OTP_GENERATION_SUCCESSFUL = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "sendOTP";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "send OTP";
  eObj["subCategory"] = "OTP success";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "otp_generation_successful", getGaEventObj(eObj));
};

const EVENT_OTP_GENERATION_FAILED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "sendOTP";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "send OTP";
  eObj["subCategory"] = "OTP failed";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "otp_generation_failed", getGaEventObj(eObj));
};

const EVENT_LOGIN_SUCCESSFUL = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "login success";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "login_successful", getGaEventObj(eObj));
};

const EVENT_LOGIN_STATUS = (eObj = {}) => {
  eObj["sectionName"] = "login";
  setEvents("amplitude", "login_status", getAmplitudeEventObj(eObj));
};

const EVENT_LOGIN_FAILED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "login";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "login failed";

  //setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "login_failed", getGaEventObj(eObj));
};

const EVENT_CLICK_HELP_TRACK_ORDER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "help";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "Help Clicked";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "help_button_click", getGaEventObj(eObj));
};

const EVENT_CLICK_REORDER = (eObj = {}) => {
  eObj["userAction"] = "repeat order";
  eObj["sectionName"] = "previous order card";
  setEvents("amplitude", "repeat_order", getAmplitudeEventObj(eObj));
  setEvents("ga", "reorder", getGaEventObj(eObj));
};

const EVENT_CLICK_ORDER_DETAIL = (eObj = {}) => {
  eObj["userAction"] = "past order card clicked";
  ((eObj["category"] = "not rated"), (eObj["subcategory"] = "NA"));
  setEvents("amplitude", "past_order_card", getAmplitudeEventObj(eObj));
  setEvents("ga", "order_detail_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEW_ALL_PREVIOUS_ORDERS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "reorder";

  setEvents("ga", "viewall_button_previous_order", getGaEventObj(eObj));
};

const EVENT_CLICK_OFFER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "promotion click";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "offer_view_more", getGaEventObj(eObj));
};

const EVENT_CLICK_REMOVE_OFFER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "ecommerce";
  eObj["subCategory"] = "coupon removed";

  setEvents("ga", "remove_coupon_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_OFFER_SELECT = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "apply_offer_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_APPLYOFFERSUCCESS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "apply_offer_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_APPLYOFFERFAILURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";
  eObj["sectionPosition"] = "4";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "apply_offer_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_OSBACK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["eventAction"] = "physical back";
  eObj["sectionName"] = "back button OS";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "back button by OS";

  setEvents("amplitude", "physical_back", getAmplitudeEventObj(eObj));
  setEvents("ga", "physical_back_button", getGaEventObj(eObj));
};

const EVENT_CLICK_CALL_TRACK_ORDER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "call";
  eObj["sectionPosition"] = "3";
  eObj["category"] = "Call";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "call_delivery_partner", getGaEventObj(eObj));
};

const EVENT_CLICK_DOWNLOAD_BILL_TRACK_ORDER = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "download bill";
  eObj["sectionPosition"] = "5";
  eObj["category"] = "Download Bill";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "download_bill", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEW_DETAILED_BILL = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "detailed bill";
  eObj["sectionPosition"] = "5";
  eObj["category"] = "detailed Bill";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "view_detailed_bill", getGaEventObj(eObj));
};

const EVENT_CLICK_PWABACK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "back button in app";
  eObj["sectionPosition"] = "1";
  eObj["category"] = "back button in app";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "UI_back_button", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_RESTAURANT_SELECTION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_IMPRESSION_NO_RESTAURANT_AVAILABLE = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionPosition"] = "1";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "no_restaurant_available", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_NO_DELIVERY_ZONE = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionPosition"] = "1";
  eObj["sectionName"] = "address selection";
  eObj["category"] = "address not deliverable";

  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
  setEvents("ga", "no_delivery_zone", getGaEventObj(eObj));
};

const EVENT_CLICK_MAP_OR_LIST_VIEW = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionPosition"] = "2";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  if (eObj["subCategory"] == "map") {
    setEvents("ga", "map_view_option_clicked", getGaEventObj(eObj));
  }
};

const EVENT_CLICK_RESTAURANT_SELECTION = (eObj = {}) => {
  eObj["userAction"] = "click";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "restaurant_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_BOTTOM_STICKY_MENU = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Bottom sticky - menu";
  eObj["category"] = "opened";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "floating_menu_button_clicked", getGaEventObj(eObj));
};

const EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Bottom sticky - menu";
  eObj["category"] = "category selected";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_OPTIN_POPUP_ADD_NEW = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "optin popup";
  eObj["category"] = "optin poup add new";

  setEvents("ga", "optin_popup_add_new", getGaEventObj(eObj));
};

const EVENT_CLICK_MINICART_ADD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "minicart popup";
  eObj["category"] = "minicart poup add";

  //setEvents("ga", "edit_combo_add", getGaEventObj(eObj));
};

const EVENT_CLICK_CARTUPSELL_ADD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "you may also like";
  eObj["category"] = "add item";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_MINICART_REMOVE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "minicart popup";
  eObj["category"] = "minicart poup remove";

  //setEvents("ga", "edit_combo_remove", getGaEventObj(eObj));
};

const EVENT_CLICK_MINICART_UPDATE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "minicart popup";
  eObj["category"] = "minicart poup update";

  //setEvents("ga", "update_cart_click_edit_combo", getGaEventObj(eObj));
};

const EVENT_CLICK_COMBO_ADD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "combo";
  eObj["category"] = "combo add";

  setEvents("ga", "edit_combo_add", getGaEventObj(eObj));
};

const EVENT_CLICK_COMBO_REMOVE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "combo";
  eObj["category"] = "combo remove";

  setEvents("ga", "edit_combo_remove", getGaEventObj(eObj));
};

const EVENT_CLICK_OPTIN_POPUP_REPEAT_LAST = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "optin popup";
  eObj["category"] = "optin poup repeat last";

  setEvents("ga", "optin_popup_repeat_last", getGaEventObj(eObj));
};

const EVENT_IMPRESSION_TIPOPTIONS = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "tip delivery partner";

  setEvents("ga", "tipping_delivery_partner_shown", getGaEventObj(eObj));
};

const EVENT_CLICK_TIPOPTIONS_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "tip amount selected";

  eObj["eventType"] = "tip click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "tips_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_TIPOTHER_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "tip amount selected - other";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "tips_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_TIP_UNSELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "remove";

  eObj["eventType"] = "remove click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_TIPENABLEFORFUTURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "auto tipping selected";
  eObj["eventType"] = "checkbox click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_tip_option_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_TIPDISABLEFORFUTURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "tip delivery partner";
  eObj["category"] = "auto tipping removed";
  eObj["eventType"] = "checkbox click";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_tip_option_deselected", getGaEventObj(eObj));
};

const EVENT_TIP_ERROR = (eObj = {}) => {
  eObj["eventType"] = "error";
  eObj["sectionName"] = "tip delivery partner";

  setEvents("amplitude", "Tip Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "auto_tip_option_deselected", getGaEventObj(eObj));
};

const EVENT_CLICK_DELIVERYINSTRUCTION = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "delivery instruction";
  eObj["category"] = "delivery instruction";
  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "delivery_instruction_interacted", getGaEventObj(eObj));
};

const EVENT_CLICK_CARTCHANGEADDRESS = (eObj = {}) => {
  eObj["userAction"] = "change location click";
  eObj["sectionName"] = "cart address section";
  eObj["category"] = "change address";

  setEvents("amplitude", "change_location", getAmplitudeEventObj(eObj));
  setEvents("ga", "change_address_click", getGaEventObj(eObj));
};

const EVENT_NEW_ADDRESS_ADDED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "shipping info added";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = {
    currency: "INR",
    value: store.getters[keyMapsGetter.CART_TOTAL],
    coupon: LocalStorageFunc.getCouponCode(),
    shipping_tier: LocalStorageFunc.getDeliveryType(),
    ...getGaEcommerceValueForAllItem(),
  };
  setEvents("ga", "add_shipping_info", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_MODAL_OPEN = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "advance order option interacted";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_option_interacted", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_DATE_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "advance order date selected";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_date_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_TIME_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "advance order time selected";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_time_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_DELIVERYTIME_DROPDOWN = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "set delivery time";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "delivery_time_dropdown_interacted", getGaEventObj(eObj));
};

const EVENT_CLICK_INSTANT_DELIVERY = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "instant delivery";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "instant_delivery_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_SCHEDULE_DELIVERY = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "schedule delivery";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "schedule_delivery_selected", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_FLOW_DONE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "set delivery time";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "advance_order_flow_completed", getGaEventObj(eObj));
};

const EVENT_CLICK_ADVANCE_ORDER_TIMEDIFF = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "advanced order";
  eObj["category"] = "set delivery time";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_VIEWMORECARTOFFERS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "coupon";
  eObj["category"] = "view more offers";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "view_all_offers", getGaEventObj(eObj));
};

const EVENT_CLICK_VIEWMORE_OFFER_CARD = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "offer";
  eObj["category"] = eObj["couponCode"];
  eObj["subCategory"] = "view more";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
  setEvents("ga", "offer_view_more", getGaEventObj(eObj));
};

const EVENT_CLICK_APPLYMANUALCOUPONSUCCESS = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "coupon";
  eObj["subCategory"] = "successful";
  eObj["discountAmount"] = "";
  eObj["cartValue"] = "";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_APPLYMANUALCOUPONFAILURE = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "coupon";
  eObj["subCategory"] = "failed";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_CARTSUBMIT = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["category"] = "proceed to pay";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));

  eObj["ecommerce"] = getGaEcommerceValueForAllItem();
  setEvents("ga", "begin_checkout", getGaEventObj(eObj));
};

const EVENT_CLICK_CARTCONTINUE = (eObj = {}) => {
  eObj["userAction"] = "login cta cart click";
  eObj["sectionName"] = "login";
  setEvents("amplitude", "login_cart", getAmplitudeEventObj(eObj));
};

const EVENT_SKIP_LOGIN = (eObj = {}) => {
  eObj["userAction"] = "skip login";
  setEvents("amplitude", "skip_login", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_CART_EXPLOREMENU = (eObj = {}) => {
  eObj["userAction"] = "explore_menu";

  setEvents("amplitude", "explore_menu", getAmplitudeEventObj(eObj));
  setEvents("ga", "explore_menu_click", getGaEventObj(eObj));
};

// NG-Cart event

const EVENT_CART_VIEWED = (eObj = {}) => {
  eObj["userAction"] = "View Cart";
  eObj["sectionName"] = "Cart";

  setEvents("amplitude", "Cart Viewed", getAmplitudeEventObj(eObj));
  setEvents("ga", "cart_viewed", getGaEventObj(eObj));
};

const EVENT_CART_END = (eObj = {}) => {
  eObj["userAction"] = "End";
  eObj["sectionName"] = "End of Cart page";
  eObj["category"] = "Cart Page Ended";

  setEvents("amplitude", "Cart End", getAmplitudeEventObj(eObj));
  setEvents("ga", "cart_end", getGaEventObj(eObj));
};

const EVENT_CLICK_ADD_MORE_ITEMS = (eObj = {}) => {
  eObj["userAction"] = "Add More Items";
  eObj["sectionName"] = "Items Added";
  eObj["subSectionName"] = "Add More Items";

  setEvents("amplitude", "add_more_item_click", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_COUPONS_TOP_BAR = (eObj = {}) => {
  eObj["userAction"] = "Go to Coupon Page";
  eObj["sectionName"] = "Top Bar";
  eObj["state"] = "Active";
  eObj["eventLabel"] = "Percentage Coupons";

  setEvents("amplitude", "coupon", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_PLUS_ONE = (eObj = {}) => {
  eObj["userAction"] = "Add to Cart Click";
  eObj["sectionName"] = "Items Added";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_MINUS_ONE = (eObj = {}) => {
  eObj["userAction"] = "Remove Item From Cart";
  eObj["sectionName"] = "Items Added";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_REMOVE_LAST_ITEM = (eObj = {}) => {
  eObj["category"] = "Remove Item From Cart";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

// Cart Upsell Events

const EVENT_CROSS_SELL_CART = (eObj = {}) => {
  eObj["sectionName"] = "CrossSell";

  setEvents("amplitude", "CrossSell", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE = (eObj = {}) => {
  eObj["userAction"] = "Add Item to Cart";
  eObj["sectionName"] = "Cross Sell";

  setEvents("amplitude", "Cart_Click", getAmplitudeEventObj(eObj));
};

const EVENT_CART_CROSS_SELL_COLLAPSE = (eObj = {}) => {
  eObj["userAction"] = "Collapse";
  eObj["sectionName"] = "Cross Sell";

  setEvents("amplitude", "CrossSell", getAmplitudeEventObj(eObj));
};

// CART ADDRESS EVENTS
const EVENT_ADDRESS_STATUS = (eObj = {}) => {
  eObj["userAction"] = "Address Status";
  eObj["subSectionName"] = "Address";

  setEvents("amplitude", "Address Status", getAmplitudeEventObj(eObj));
};

const EVENT_ADD_SELECT_ADDRESS = (eObj = {}) => {
  eObj["userAction"] = "Add New Address";
  eObj["subSectionName"] = "Address";

  setEvents("amplitude", "Add_select_address", getAmplitudeEventObj(eObj));
};

const EVENT_SET_LOCATION_AND_ADD_ADDRESS = (eObj = {}) => {
  eObj["userAction"] = "Set Location & Add Address";
  eObj["eventCategory"] = "Saved Address at cart";

  setEvents(
    "amplitude",
    "set_location_and_Add_Address",
    getAmplitudeEventObj(eObj),
  );
};

// advance order events

const EVENT_ADVANCE_ORDER_CLICK = (eObj = {}) => {
  eObj["sectionName"] = "advanced order";
  setEvents("amplitude", "click", getAmplitudeEventObj(eObj));
};

// cart offer events

const EVENT_CART_COUPON = (eObj = {}) => {
  setEvents("amplitude", "coupon", getAmplitudeEventObj(eObj));
};

const EVENT_APPLY_CLICK_CART_COUPON = (eObj = {}) => {
  eObj["sectionName"] = "Savings & Rewards";
  eObj["eventCategory"] = "Coupon Card";
  eObj["subSectionName"] = "Best Offer on Cart";
  eObj["eventAction"] = "Apply Click";

  setEvents("amplitude", "applyClick", getAmplitudeEventObj(eObj));
};
const EVENT_COUPON_APPLICATION_SUCCESS_CONFETTI_LAUNCHED = (eObj = {}) => {
  eObj["eventCategory"] = "Confetti Launched";
  eObj["eventAction"] = "Launch";

  setEvents(
    "amplitude",
    "coupon_application_success",
    getAmplitudeEventObj(eObj),
  );
};
const EVENT_DIALOGUE_LAUNCHED = (eObj = {}) => {
  eObj["eventCategory"] = "Dialogue";

  setEvents("amplitude", "Dialogue", getAmplitudeEventObj(eObj));
};
const EVENT_DIALOGUE_CTA_CLICK = (eObj = {}) => {
  setEvents("amplitude", "Dialogue_Action", getAmplitudeEventObj(eObj));
};

const EVENT_LOCATION_CLICK = (eObj = {}) => {
  eObj["userAction"] = "click";
  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_DETAILS_PAGE_CLICK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "Order Details page";
  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_DETAILS_PAGE_IMPRESSION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "Order Details page";
  setEvents("amplitude", "Impression", getAmplitudeEventObj(eObj));
};

const EVENT_EXPLORE_MENU_CATEGORY_CLICK = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "explore menu";
  eObj["sectionPosition"] = "5";

  setEvents("amplitude", "Click", getAmplitudeEventObj(eObj));
};

const EVENT_BEGIN_CHECKOUT = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";
  eObj["checkoutOption"] = "Place Order";
  eObj["checkoutStep"] = "1";
  eObj["checkoutStage"] = "checkout initiated";
  //   Event Label=<>,Item Name : [Chicken Pizza, Chicken Calzon, Garlic Bread],
  //   Item SKU (as a 1D array)=<>,
  // Ecom Category (as an array): [Pizza, Sides, Sides], Quantity (as an array): [1,1,2], Price (as an array)=<>,

  //  Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>, Address=<>

  setEvents("amplitude", "begin_checkout", getAmplitudeEventObj(eObj));
  setEvents("meta", "FB_InitiateCheckout", {});
};

const EVENT_CHECKOUT_PROGRESS = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";
  // checkout_option=Select Address,
  // Item Name = [Chicken Pizza, Chicken Calzon, Garlic Bread],
  // Item SKU (as a 1D array)=<>, Ecom Category (as an array)=[Pizza, Sides, Sides],
  // Quantity (as an array)=[1,1,2], Price (as an array)=<>, Size(as an array)=<>,
  // Crust(as an array)=<>,
  // checkout_step=2,
  // Checkout Stage=checkout initiated,
  // Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>,
  // Address=<>,
  // Screen Name=<>, Previous Screen Name=<>

  setEvents("amplitude", "checkout_progress", getAmplitudeEventObj(eObj));
};

const EVENT_UNKNOWN_ORDER_STATUS = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";
  // checkout_option=Select Address,
  // Item Name = [Chicken Pizza, Chicken Calzon, Garlic Bread],
  // Item SKU (as a 1D array)=<>, Ecom Category (as an array)=[Pizza, Sides, Sides],
  // Quantity (as an array)=[1,1,2], Price (as an array)=<>, Size(as an array)=<>,
  // Crust(as an array)=<>,
  // checkout_step=2,
  // Checkout Stage=checkout initiated,
  // Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>,
  // Address=<>,
  // Screen Name=<>, Previous Screen Name=<>

  setEvents("amplitude", "unknown_order_status", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_COMPLETED = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Transaction";
  eObj["eventLabel"] = "Success";
  eObj["checkoutStage"] = "order success";
  //Item Name : [Chicken Pizza, Chicken Calzon, Garlic Bread], Item SKU (as a 1D array)=<>, Quantity (as an array): [1,1,2], Total Quantity:=<>, Subtotal (as an array):=<>, Tax=<>, Subtotal pre-discount(as an array)=<>, Delivery Charge=<>, Discount Amount Coupon=<>, Discount Amount Wallet=<>, Carry Bag Charge=<>, Coupon Name=<Coupon Applied on Cart i.e. any coupon or EDV coupon>, Card ID=<>, Order ID=<>, Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>, Address=<>,

  setEvents("amplitude", "OrderCompleted", getAmplitudeEventObj(eObj));
};

const EVENT_PRODUCT_PURCHASED = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Transaction";
  eObj["eventLabel"] = "Success";
  eObj["checkoutStage"] = "order success";
  //Item Name : [Chicken Pizza, Chicken Calzon, Garlic Bread], Item SKU (as a 1D array)=<>, Quantity (as an array): [1,1,2], Total Quantity:=<>, Subtotal (as an array):=<>, Tax=<>, Subtotal pre-discount(as an array)=<>, Delivery Charge=<>, Discount Amount Coupon=<>, Discount Amount Wallet=<>, Carry Bag Charge=<>, Coupon Name=<Coupon Applied on Cart i.e. any coupon or EDV coupon>, Card ID=<>, Order ID=<>, Payment Method Saved=<yes/no>, Payment Method=<>, Address Saved=<yes/no>, Address=<>,

  setEvents("amplitude", "Product Purchased", getAmplitudeEventObj(eObj));
  setEvents("meta", "FB_Purchase", {});
};

const EVENT_ORDER_FAILED = (eObj = {}) => {
  eObj["eventCategory"] = "Ecommerce";
  eObj["eventAction"] = "Checkout";

  setEvents("amplitude", "faliure_order", getAmplitudeEventObj(eObj));
  setEvents("meta", "FB_Web_Order_Failed", {});
};

const EVENT_ITEM_CUSTOMISE_SHOWN = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "customisable drawer";
  eObj["category"] = "customise drawer shown";
  setEvents("amplitude", "item_customise", getAmplitudeEventObj(eObj));
};
const EVENT_ITEM_CUSTOMISE_OPTION_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "click";
  eObj["sectionName"] = "customisable drawer";
  eObj["category"] = "customisation selected";

  setEvents("amplitude", "item_customise", getAmplitudeEventObj(eObj));
};

const EVENT_CLICK_ORDER_FILTER = (eObj = {}) => {
  eObj["userAction"] = "click";

  setEvents("amplitude", "previous_order_type", getAmplitudeEventObj(eObj));

  // section_position=<index of the filter>,
  // category=<Filter Selected/Filter Removed>,
  // subcategory=<filter-name>,
};

const EVENT_ALLOW_LOCATION_POPUP_VIEW = (eObj = {}) => {
  eObj["userAction"] = "popup view";
  eObj["sectionName"] = "location popup";

  setEvents("amplitude", "allow_location_popup", getAmplitudeEventObj(eObj));
};
const EVENT_ALLOW_LOCATION_POPUP_ACTION = (eObj = {}) => {
  //  section_position=
  //  position_within_section=
  //  category= <allow/deny>
  //  subcategory= < greater than 3sec/ less than 3sec>

  eObj["userAction"] = "popup action";
  eObj["sectionName"] = "location popup";

  setEvents("amplitude", "allow_location_popup", getAmplitudeEventObj(eObj));
};

const EVENT_LOCATION_BOTTOM_DRAWER_VIEW = (eObj = {}) => {
  eObj["userAction"] = "Location Nudge Impression";

  setEvents("amplitude", "location_bottom_drawer", getAmplitudeEventObj(eObj));
};

const EVENT_LOCATION_BOTTOM_DRAWER_ACTION = (eObj = {}) => {
  setEvents("amplitude", "location_bottom_drawer", getAmplitudeEventObj(eObj));
};

const EVENT_LOCATION_ADDRESS_INPUT = (eObj = {}) => {
  setEvents("amplitude", "address_input", getAmplitudeEventObj(eObj));
};

const EVENT_MAP_DRAGGED = (eObj = {}) => {
  eObj["userAction"] = "map engaged";
  eObj["sectionName"] = "change location";
  eObj["category"] = "dragged map to detect location";
  eObj["sectionPosition"] = 2;
  eObj["positionWithinSection"] = 1;

  setEvents("amplitude", "map_dragged", getAmplitudeEventObj(eObj));
};

const EVENT_CONFIRM_LOCATION = (eObj = {}) => {
  eObj["userAction"] = "location confirmed";
  eObj["sectionName"] = "change location";

  setEvents("amplitude", "confirm_location", getAmplitudeEventObj(eObj));
};

const EVENT_DENIED_LOCATION_POPUP = (eObj = {}) => {
  setEvents("amplitude", "denied_location_popup", getAmplitudeEventObj(eObj));
};

const EVENT_ADD_ADDRESS_CART = (eObj = {}) => {
  eObj["userAction"] = "address at cart";
  eObj["sectionName"] = "change location";
  //  section_position=
  //  position_within_section=
  //  category= <add new address/ saved address/ add address/ "add/select address">
  //  subcategory= <logged in/ not logged in>
  setEvents("amplitude", "add_address_cart", getAmplitudeEventObj(eObj));
};

const EVENT_ADDRESS_SELECTION_DRAWER = (eObj = {}) => {
  eObj["sectionName"] = "address drawer";

  setEvents(
    "amplitude",
    "address_selection_drawer",
    getAmplitudeEventObj(eObj),
  );
};

const EVENT_SAVE_ADDRESS_LOCATION = (eObj = {}) => {
  eObj["userAction"] = "address input";
  eObj["sectionName"] = "address input form";
  // section_position=
  // position_within_section=
  // category=
  // subcategory= <ordering for someone else/ordering for self>
  setEvents("amplitude", "save_address_location", getAmplitudeEventObj(eObj));
};

const EVENT_LOGIN_DEAD_CLICK = (eObj = {}) => {
  eObj["userAction"] = "dead click";
  eObj["sectionName"] = "login - carousel";
  setEvents("amplitude", "dead_clicks", getAmplitudeEventObj(eObj));
};

const EVENT_PROFILE_CLICK = (eObj = {}) => {
  eObj["sectionName"] = "hamburger";
  setEvents("amplitude", "profile", getAmplitudeEventObj(eObj));
};

const EVENT_LOGOUT_CLICK = (eObj = {}) => {
  eObj["userAction"] = "logout";
  eObj["sectionName"] = "hamburger";
  setEvents("amplitude", "logout_click", getAmplitudeEventObj(eObj));
};

const EVENT_HAMBURGER_IMPRESSION = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["sectionName"] = "hamburger";
  setEvents("amplitude", "hamburger", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_HISTORY_HELP_CLICK = (eObj = {}) => {
  eObj["userAction"] = "need help";
  eObj["sectionName"] = "previous order card";
  setEvents("amplitude", "need_help", getAmplitudeEventObj(eObj));
};

const EVENT_ITEM_ADD = (eObj = {}) => {
  eObj["userAction"] = "add";
  setEvents("amplitude", "item_click_or_add", getAmplitudeEventObj(eObj));
};

const EVENT_CUSTOMIZE_SCREEN = (eObj = {}) => {
  setEvents("amplitude", "pageView", getAmplitudeEventObj(eObj));
};

const EVENT_CUSTOMIZED_PRODUCT = (eObj = {}) => {
  eObj["userAction"] = "customize product";
  setEvents("amplitude", "customized_product", getAmplitudeEventObj(eObj));
};

const EVENT_MENU_CATEGORY_FLOATER = (eObj = {}) => {
  setEvents("amplitude", "menu_category_floater", getAmplitudeEventObj(eObj));
};

const EVENT_VEG_MODE = (eObj = {}) => {
  eObj["sectionName"] = "menu filter";
  setEvents("amplitude", "veg_mode", getAmplitudeEventObj(eObj));
};

const EVENT_PRODUCT_ADD_REMOVE_DRAWER = (eObj = {}) => {
  setEvents(
    "amplitude",
    "product_add_remove_drawer",
    getAmplitudeEventObj(eObj),
  );
};

const EVENT_MENU_CATEGORY_SELECTED = (eObj = {}) => {
  eObj["userAction"] = "menu category selected";
  eObj["sectionName"] = "delectable menu";
  setEvents("amplitude", "menu_category_cards", getAmplitudeEventObj(eObj));
};

const EVENT_OFFER_HOME = (eObj = {}) => {
  eObj["sectionName"] = "homepage offers";
  setEvents("amplitude", "offer_home", getAmplitudeEventObj(eObj));
};

const EVENT_OFFER_NUDGE = (eObj = {}) => {
  eObj["sectionName"] = "offer nudge";
  setEvents("amplitude", "offer_nudge", getAmplitudeEventObj(eObj));
};

const EVENT_CHANGE_LOCATION = (eObj = {}) => {
  eObj["userAction"] = "change location click";
  eObj["sectionName"] = "home address section";
  setEvents("amplitude", "change_location", getAmplitudeEventObj(eObj));
};

const EVENT_REORDER_HOME = (eObj = {}) => {
  eObj["userAction"] = "re-order click";
  eObj["sectionName"] = "order again";
  setEvents("amplitude", "re-order_home", getAmplitudeEventObj(eObj));
};

const EVENT_ADD_FROM_SEARCH = (eObj = {}) => {
  eObj["userAction"] = "add from search";
  eObj["sectionName"] = "search options";
  setEvents("amplitude", "add_from_search", getAmplitudeEventObj(eObj));
};

const EVENT_SEARCH_BACK_CLICK = (eObj = {}) => {
  eObj["userAction"] = "back button clicked";
  eObj["sectionName"] = "product search on menu";
  setEvents("amplitude", "back_button", getAmplitudeEventObj(eObj));
};

const EVENT_POPUP = (eObj = {}) => {
  eObj["userAction"] = "impression";
  eObj["category"] = "popup";
  setEvents("amplitude", "popup", getAmplitudeEventObj(eObj));
};

const EVENT_STORE_SELECTION_DRAWER = (eObj = {}) => {
  setEvents("amplitude", "store_selection_drawer", getAmplitudeEventObj(eObj));
};

const EVENT_OFFER_SCREEN = (eObj = {}) => {
  setEvents("amplitude", "offer_screen", getAmplitudeEventObj(eObj));
};

const EVENT_OFFER_CARD = (eObj = {}) => {
  setEvents("amplitude", "offer_card", getAmplitudeEventObj(eObj));
};

const EVENT_HOMEPAGE_ALERT = (eObj = {}) => {
  eObj["sectionName"] = "alert banners";
  setEvents("amplitude", "homepage_alerts", getAmplitudeEventObj(eObj));
};
// Cart events
const EVENT_TAX_SECTION = (eObj = {}) => {
  setEvents("amplitude", "tax", { ...getAmplitudeEventObj(eObj), ...eObj });
};

const EVENT_DISCOUNT_VIEW = (eObj = {}) => {
  setEvents("amplitude", "discount_view", {
    ...getAmplitudeEventObj(eObj),
    ...eObj,
  });
};

const EVENT_ORDER_MODE_CART = (eObj = {}) => {
  //   "user_action= <click/selected>
  // current_mode = <current order mode as delivery/dinein/takeaway>
  // updated_mode = <updated order mode as delivery/dinein/takeaway>
  // distance_diff = <distance between current order mode and updated order mode/NA if switched from DineIn/takeaway to Delivery>
  // delivery_time = <delivery time displayed/delivery time if user switches from  DineIn/takeaway to Delivery >
  setEvents("amplitude", "order_mode_cart", getAmplitudeEventObj(eObj));
};

const EVENT_ORDER_MODE_SELECTION = (eObj = {}) => {
  //   "user_action= <click/selected>
  // current_mode = <current order mode as delivery/dinein/takeaway>
  // updated_mode = <updated order mode as delivery/dinein/takeaway>
  // distance_diff = <distance between current order mode and updated order mode/NA if switched from DineIn/takeaway to Delivery>
  // delivery_time = <delivery time displayed/delivery time if user switches from  DineIn/takeaway to Delivery >
  setEvents("amplitude", "order_mode_selection", getAmplitudeEventObj(eObj));
};

const EVENT_SCHEDULE_ORDER = (eObj = {}) => {
  eObj["userAction"] = "order scheduled";
  // current_mode = <current order mode as delivery/dinein/takeaway>
  // is_scheduled_today = <1/0>
  // delivery_time = <order delivery/pickup time difference from current time in day:hour:min ></order>
  setEvents("amplitude", "schedule_order", getAmplitudeEventObj(eObj));
};

const EVENT_PAYMENT_METHOD_CLICK = (eObj = {}) => {
  eObj["userAction"] = "click payment method";
  setEvents("amplitude", "payment_method_click", getAmplitudeEventObj(eObj));
};

const EVENT_VIEW_ALL_OFFERS = (eObj = {}) => {
  setEvents("amplitude", "view_all_offers", getAmplitudeEventObj(eObj));
};

const EVENT_EDIT_ITEM = (eObj = {}) => {
  eObj["userAction"] = "edit item click";
  setEvents("amplitude", "edit_item", getAmplitudeEventObj(eObj));
};

const EVENT_PAY_CTA_CLICK = (eObj = {}) => {
  eObj["userAction"] = "pay at cart click";
  eObj["sectionName"] = "pay CTA";
  setEvents("amplitude", "edit_item", getAmplitudeEventObj(eObj));
};
// --st here
const EVENT_PLACING_ORDER_DRAWER = (eObj = {}) => {
  eObj["sectionName"] = "placing order drawer";
  //   user_action= <impression/cancel>
  //   section_position= <no of seconds the drawer is visible to the user>
  //  category = <cancelled CTA click>
  //  subcategory = <no. of seconds as 1/2/3/4 when cancel CTA is clicked since drawer launch>
  //  payment_method = <name of the payment method
  //  bank_or_mode = <bank name/upi app name/wallet name/etc..>
  //  subtotal = <amount to be paid by customer post discount and post tax application>
  //  cart_id = <cart id>
  setEvents("amplitude", "placing_order_drawer", getAmplitudeEventObj(eObj));
};

const EVENT_BACKEND_VALIDATION = (eObj = {}) => {
  eObj["userAction"] = "automated backend validation of cart";
  // category = <success/failed>
  // subcategory = <reason for not able to proceed to begin checkout process like invalid coupon, invalid item in cart, store offline...etc>
  // payment_method = <name of the payment method>
  // bank_or_mode = <bank name/upi app name/wallet name/etc..>
  // subtotal = <amount to be paid by customer post discount and post tax application>
  // cart_id = <cart id>
  setEvents("amplitude", "backend_validation", getAmplitudeEventObj(eObj));
};

const EVENT_CVV_DRAWER = (eObj = {}) => {
  eObj["sectionName"] = "enter cvv";

  // user_action= <impression/pay>
  // bank_or_mode = <bank name/upi app name/wallet name/etc..>
  // category = <success/failed>
  // subcategory = <failed msg>
  // payment_method = <cc/dc/...>
  // subtotal = <amount to be paid by customer post discount and post tax application>
  // cart_id = <cart id>
  setEvents("amplitude", "cvv_drawer", getAmplitudeEventObj(eObj));
};

const EVENT_PAYMENT_OTP_DRAWER = (eObj = {}) => {
  eObj["sectionName"] = "payment otp enter";
  //   user_action= <impression/pay>
  //  bank_or_mode = <bank name/upi app name/wallet name/etc..>
  //  category = <success/fail>
  //  subcategory = <failed msg>
  //  payment_method = <name of the payment method like cc/dc...>
  //  subtotal = <amount to be paid by customer post discount and post tax application>
  //  cart_id = <cart id>
  setEvents("amplitude", "payment_otp_drawer", getAmplitudeEventObj(eObj));
};

const EVENT_PAYMENT_STATUS = (eObj = {}) => {
  eObj["userAction"] = "payment confirmation status";
  //   section_name= payment success or failed
  //  bank_or_mode = <bank name/upi app name/wallet name/etc..>
  //  category = <success/failed>
  //  subcategory = <failed msg>
  //  payment_method = <cc/dc/...>
  //  subtotal = <amount to be paid by customer post discount and post tax application>
  //  cart_id = <cart id>
  setEvents("amplitude", "payment_status", getAmplitudeEventObj(eObj));
};

const EVENT_RETRY_PAYMENT_DRAWER = (eObj = {}) => {
  eObj["category"] = "failed";
  eObj["sectionName"] = "payment failed drawer";
  //   user_action= <impression/retry failed payment>
  //  bank_or_mode = <bank name/upi app name/wallet name/etc..>
  //  subcategory = <failed msg>
  //  payment_method = <cc/dc/...>
  //  updated payment_method = <cc/dc/...>
  //  updated bank_or_mode = <bank name/upi app name/wallet name/etc..>
  //  subtotal = <amount to be paid by customer post discount and post tax application>
  //  cart_id = <cart id>
  setEvents("amplitude", "retry_payment_drawer", getAmplitudeEventObj(eObj));
};

const EVENT_WALLET_AMOUNT = (eObj = {}) => {
  eObj["sectionName"] = "wallet amount at cart";
  // user_action= <applied/removed>
  // popeyes_wallet_amount = <amount used from popeyes wallet for payment>
  setEvents("amplitude", "wallet_amount", getAmplitudeEventObj(eObj));
};

const EVENT_CONTINUE_NEW_ORDER = (eObj = {}) => {
  eObj["sectionName"] = "new order drawer";
  //  user_action= <impression/ track last/order/ continue with new order>
  setEvents("amplitude", "continue_new_order", getAmplitudeEventObj(eObj));
};

const EVENT_USE_WALLET_CASH = (eObj = {}) => {
  eObj["eventAction"] = "Click Wallet Cashback";
  eObj["eventCategory"] = "Ecommerce";
  // Cart id = <cart id>
  // Coupon Name = <name of the coupon/offer applied>
  // Coupon Amount = <amount of discount provided by coupon/offer>
  // wallet_amount  = <amount used from wallet>
  // Total Cashback Available = <total cashback available in wallet>
  // Subtotal = <total price of items w/o coupon or taxes>
  // Default Payment Method=<>
  setEvents("amplitude", "Use_Wallet_Cash", getAmplitudeEventObj(eObj));
};

const EVENT_REMOVE_WALLET_CASH = (eObj = {}) => {
  eObj["eventAction"] = "removed cashback from cart";
  eObj["eventCategory"] = "Ecommerce";
  // Cart id = <cart id>
  // Coupon Name = <name of the coupon/offer applied>
  // Coupon Amount = <amount of discount provided by coupon/offer>
  // wallet_amount  = <amount used from wallet>
  // Total Cashback Available = <total cashback available in wallet>
  // Subtotal = <total price of items w/o coupon or taxes>
  // Default Payment Method=<>
  setEvents("amplitude", "Remove_Wallet_Cash", getAmplitudeEventObj(eObj));
};
const EVENT_CARTPAGEPAYMENT_MODE = (eObj = {}) => {
  eObj["eventAction"] = "default";
  eObj["eventCategory"] = "Cart Page Payment Mode";
  // Event Label = <Payment mode at cart like google upi/ cc/dc/cash etc..>
  // previous_payment_mode = <pass the previous payment mode in case of manually_selected/NA>
  // Cart id = <cart id>
  // Coupon Name = <name of the coupon/offer applied/None>
  // Coupon Amount = <amount of discount provided by coupon/offer/0>
  // wallet_amount = <amount used from wallet>
  setEvents("amplitude", "CartPagePayment_Mode", getAmplitudeEventObj(eObj));
};

export {
  setEvents,
  loadAmplitudeUnsentEvents,
  loadGaUnsentEvents,
  updateAmplitudeUserProperties,
  getAmplitudeEventObj,
  EVENT_PAGEVIEW_HOMEPAGE,
  EVENT_CLICK_SEARCHICON,
  EVENT_PAGEVIEW_SEARCHPAGE,
  EVENT_PAGEVIEW_LOGINPAGE,
  EVENT_PAGEVIEW_OFFERSPAGE,
  EVENT_PAGEVIEW_PROFILEPAGE,
  EVENT_PAGEVIEW_CARTPAGE,
  EVENT_PAGEVIEW_LOCATIONPAGE,
  EVENT_PAGEVIEW_FAVOURITEPAGE,
  EVENT_PAGEVIEW_ORDERHISTORYPAGE,
  EVENT_PAGEVIEW_MENUPAGE,
  EVENT_PAGEVIEW_ADDRESSESPAGE,
  EVENT_TYPE_SEARCHINPUT,
  EVENT_IMPRESSION_SEARCHRESULT,
  EVENT_IMPRESSION_PROMOTION,
  EVENT_IMPRESSION_OFFERS,
  EVENT_CLICK_SEARCHOPTION,
  EVENT_CLICK_PROMOTION,
  EVENT_CLICK_ORDERTYPE,
  EVENT_IMPRESSION_INLINENOTIFICATION,
  EVENT_CLICK_INLINENOTIFICATION,
  EVENT_IMPRESSION_UPSELL_ITEM,
  EVENT_CLICK_UPSELL_ITEM,
  EVENT_CLICK_FILTERS,
  EVENT_CLICK_MENU_CATEGORY,
  EVENT_CLICK_ADDRESS,
  EVENT_CLICK_BOTTOM_STICKY_BAR,
  EVENT_CLICK_FAVOURITE_BUTTON,
  EVENT_CLICK_ADDTOCART,
  EVENT_CLICK_REMOVEFROMCART,
  EVENT_CLICK_EDITITEMINCART,
  EVENT_CLICK_VIEWCART,
  EVENT_HAMBURGER_OPENED,
  EVENT_HAMBURGER_CLOSED,
  EVENT_HAMBURGER_LIST_ITEM_CLICKED,
  EVENT_LOGIN_CTA_CLICKED,
  EVENT_LOGOUT_CTA_CLICKED,
  EVENT_CLICK_TRACKORDER,
  EVENT_IMPRESSION_TRACKORDER,
  EVENT_IMPRESSION_CUSTOMIZATION,
  EVENT_CLICK_CUSTOMIZATION,
  EVENT_CLICK_CUSTOMIZATION_COMBO,
  EVENT_TYPE_MOBILENUMBER,
  EVENT_CLICK_LOGIN_SKIP,
  EVENT_CLICK_SENDOTP,
  EVENT_CLICK_CHANGEMOBILENUMBER,
  EVENT_CLICK_RESENDSMS,
  EVENT_TYPE_OTP,
  EVENT_CLICK_SUBMITOTP,
  EVENT_AUTO_LOGIN_TRIGGERED,
  EVENT_CLICK_AUTO_FETCH_MOBILE_NO,
  EVENT_OTP_GENERATION_SUCCESSFUL,
  EVENT_OTP_GENERATION_FAILED,
  EVENT_LOGIN_SUCCESSFUL,
  EVENT_LOGIN_FAILED,
  EVENT_CLICK_VIEW_ALL_PREVIOUS_ORDERS,
  EVENT_CLICK_REORDER,
  EVENT_CLICK_ORDER_DETAIL,
  EVENT_CLICK_HELP_TRACK_ORDER,
  EVENT_CLICK_CALL_TRACK_ORDER,
  EVENT_CLICK_DOWNLOAD_BILL_TRACK_ORDER,
  EVENT_CLICK_VIEW_DETAILED_BILL,
  EVENT_CLICK_OFFER,
  EVENT_CLICK_REMOVE_OFFER,
  EVENT_CLICK_APPLYOFFERSUCCESS,
  EVENT_CLICK_APPLYOFFERFAILURE,
  EVENT_CLICK_OSBACK,
  EVENT_CLICK_PWABACK,
  EVENT_IMPRESSION_RESTAURANT_SELECTION,
  EVENT_IMPRESSION_NO_RESTAURANT_AVAILABLE,
  EVENT_IMPRESSION_NO_DELIVERY_ZONE,
  EVENT_CLICK_RESTAURANT_SELECTION,
  EVENT_CLICK_MAP_OR_LIST_VIEW,
  EVENT_CLICK_BOTTOM_STICKY_MENU,
  EVENT_CLICK_CATEGORY_BOTTOM_STICKY_MENU,
  EVENT_CLICK_OPTIN_POPUP_ADD_NEW,
  EVENT_CLICK_OPTIN_POPUP_REPEAT_LAST,
  EVENT_CLICK_MINICART_ADD,
  EVENT_CLICK_CARTUPSELL_ADD,
  EVENT_CLICK_MINICART_REMOVE,
  EVENT_CLICK_MINICART_UPDATE,
  EVENT_CLICK_COMBO_ADD,
  EVENT_CLICK_COMBO_REMOVE,
  EVENT_IMPRESSION_TIPOPTIONS,
  EVENT_CLICK_TIPOPTIONS_SELECTED,
  EVENT_CLICK_TIPOTHER_SELECTED,
  EVENT_CLICK_TIP_UNSELECTED,
  EVENT_CLICK_TIPENABLEFORFUTURE,
  EVENT_CLICK_TIPDISABLEFORFUTURE,
  EVENT_TIP_ERROR,
  EVENT_CLICK_DELIVERYINSTRUCTION,
  EVENT_CLICK_CARTCHANGEADDRESS,
  EVENT_NEW_ADDRESS_ADDED,
  EVENT_CLICK_ADVANCE_ORDER_MODAL_OPEN,
  EVENT_CLICK_ADVANCE_ORDER_DATE_SELECTED,
  EVENT_CLICK_ADVANCE_ORDER_TIME_SELECTED,
  EVENT_CLICK_DELIVERYTIME_DROPDOWN,
  EVENT_CLICK_INSTANT_DELIVERY,
  EVENT_CLICK_SCHEDULE_DELIVERY,
  EVENT_CLICK_ADVANCE_ORDER_FLOW_DONE,
  EVENT_CLICK_ADVANCE_ORDER_TIMEDIFF,
  EVENT_CLICK_VIEWMORECARTOFFERS,
  EVENT_CLICK_VIEWMORE_OFFER_CARD,
  EVENT_CLICK_APPLYMANUALCOUPONSUCCESS,
  EVENT_CLICK_APPLYMANUALCOUPONFAILURE,
  EVENT_CLICK_CARTSUBMIT,
  EVENT_CLICK_CARTCONTINUE,
  EVENT_CLICK_CART_EXPLOREMENU,
  EVENT_CART_VIEWED,
  EVENT_CART_END,
  EVENT_CLICK_ADD_MORE_ITEMS,
  EVENT_CLICK_COUPONS_TOP_BAR,
  EVENT_CART_CLICK_PLUS_ONE,
  EVENT_CART_CLICK_MINUS_ONE,
  EVENT_CART_CLICK_REMOVE_LAST_ITEM,
  EVENT_CROSS_SELL_CART,
  EVENT_CART_CLICK_CROSS_SELL_PLUS_ONE,
  EVENT_CART_CROSS_SELL_COLLAPSE,
  EVENT_CLICK_OFFER_SELECT,
  EVENT_ADDRESS_STATUS,
  EVENT_ADD_SELECT_ADDRESS,
  EVENT_SET_LOCATION_AND_ADD_ADDRESS,
  EVENT_ADVANCE_ORDER_CLICK,
  EVENT_CART_COUPON,
  EVENT_APPLY_CLICK_CART_COUPON,
  EVENT_COUPON_APPLICATION_SUCCESS_CONFETTI_LAUNCHED,
  EVENT_DIALOGUE_LAUNCHED,
  EVENT_DIALOGUE_CTA_CLICK,
  EVENT_LOCATION_CLICK,
  EVENT_ORDER_DETAILS_PAGE_CLICK,
  EVENT_ORDER_DETAILS_PAGE_IMPRESSION,
  EVENT_EXPLORE_MENU_CATEGORY_CLICK,
  EVENT_BEGIN_CHECKOUT,
  EVENT_CHECKOUT_PROGRESS,
  EVENT_UNKNOWN_ORDER_STATUS,
  EVENT_ORDER_COMPLETED,
  EVENT_PRODUCT_PURCHASED,
  EVENT_ITEM_CUSTOMISE_SHOWN,
  EVENT_ITEM_CUSTOMISE_OPTION_SELECTED,
  EVENT_ORDER_FAILED,
  EVENT_CLICK_ORDER_FILTER,
  EVENT_ALLOW_LOCATION_POPUP_VIEW,
  EVENT_ALLOW_LOCATION_POPUP_ACTION,
  EVENT_LOCATION_BOTTOM_DRAWER_VIEW,
  EVENT_LOCATION_BOTTOM_DRAWER_ACTION,
  EVENT_LOCATION_ADDRESS_INPUT,
  EVENT_MAP_DRAGGED,
  EVENT_CONFIRM_LOCATION,
  EVENT_DENIED_LOCATION_POPUP,
  EVENT_ADD_ADDRESS_CART,
  EVENT_ADDRESS_SELECTION_DRAWER,
  EVENT_SAVE_ADDRESS_LOCATION,
  EVENT_LOGIN_DEAD_CLICK,
  EVENT_OTP_DETECTED,
  EVENT_SKIP_LOGIN,
  EVENT_LOGIN_STATUS,
  EVENT_PROFILE_CLICK,
  EVENT_LOGOUT_CLICK,
  EVENT_HAMBURGER_IMPRESSION,
  EVENT_ORDER_HISTORY_HELP_CLICK,
  EVENT_ITEM_ADD,
  EVENT_CUSTOMIZE_SCREEN,
  EVENT_CUSTOMIZED_PRODUCT,
  EVENT_MENU_CATEGORY_FLOATER,
  EVENT_VEG_MODE,
  EVENT_PRODUCT_ADD_REMOVE_DRAWER,
  EVENT_MENU_CATEGORY_SELECTED,
  EVENT_OFFER_HOME,
  EVENT_OFFER_NUDGE,
  EVENT_CHANGE_LOCATION,
  EVENT_REORDER_HOME,
  EVENT_ADD_FROM_SEARCH,
  EVENT_SEARCH_BACK_CLICK,
  EVENT_POPUP,
  EVENT_STORE_SELECTION_DRAWER,
  EVENT_OFFER_SCREEN,
  EVENT_OFFER_CARD,
  EVENT_HOMEPAGE_ALERT,
  EVENT_TAX_SECTION,
  EVENT_DISCOUNT_VIEW,
  EVENT_ORDER_MODE_CART,
  EVENT_SCHEDULE_ORDER,
  EVENT_PAYMENT_METHOD_CLICK,
  EVENT_VIEW_ALL_OFFERS,
  EVENT_EDIT_ITEM,
  EVENT_PAY_CTA_CLICK,
  EVENT_ORDER_MODE_SELECTION,
  EVENT_PLACING_ORDER_DRAWER,
  EVENT_BACKEND_VALIDATION,
  EVENT_CONTINUE_NEW_ORDER,
  EVENT_CVV_DRAWER,
  EVENT_PAYMENT_OTP_DRAWER,
  EVENT_PAYMENT_STATUS,
  EVENT_REMOVE_WALLET_CASH,
  EVENT_RETRY_PAYMENT_DRAWER,
  EVENT_USE_WALLET_CASH,
  EVENT_WALLET_AMOUNT,
  EVENT_CARTPAGEPAYMENT_MODE,
};
